/**
 * Die drei Arten zu rechnen, mit den Namen, die die Buchhaltung aus dem Excel
 * kennt („Trinkgeld berechnen“, „Trinkgeld getrennt“) und vorgeschlagen hat
 * (Oktober 2026). Eingeordnet wird in der API, hier stehen nur die Wörter.
 */
import type { Berechnungsart } from "./api";

export const ART_LABEL: Record<Berechnungsart, string> = {
  alle: "Trinkgeld berechnen (alle in einem Topf)",
  einzeln: "Trinkgeld getrennt (alle einzeln)",
  teil: "Trinkgeld teilgebündelt",
};

/** Für Kennzeichen in Listen, wo der volle Name zu lang wäre. */
export const ART_KURZ: Record<Berechnungsart, string> = {
  alle: "alle in einem Topf",
  einzeln: "getrennt",
  teil: "teilgebündelt",
};

/** „CBE · Yuca + Sommergarten · Winter Walk“: wer mit wem teilt. */
export function beschreibung(gruppen: readonly (readonly string[])[]): string {
  return gruppen.map((g) => g.join(" + ")).join(" · ");
}
